import mixins from 'synergycms_core/src/less/mixins';

export default {
  availModalcontent: {
    position: 'relative',
    height:'100%',
    '& $buttonContainer': {
      position: 'relative',
      margin: '0 auto'
    },
    '& $closeButton': {
      position: 'absolute',
      top: '0',
      right: '0',
      zIndex: '1',
      border: '0',
      width:'65px',
      height:'65px',
      backgroundColor: 'transparent',
      cursor:'pointer',
      padding:0,
      color: data => data.mainColor,
      font: data => '21px ' + data.fontFamily1,
      '&:lang(ar)': {
        right: 'auto',
        left: '0',
      },
      '@media (min-width: 801px)': {
        right:'20px'
      }
    },
    '& $headerModal': {
      position: 'relative',
      padding: '22px 65px 15px 15px',
      borderBottom: '1px solid #E4E4E4',
      '& $modalTitle': {
        font: data => '400 22px/29px ' + data.fontFamily1
      },
      '&:lang(ar)': {
        padding:'22px 15px 15px 65px'
      },
      '@media (min-width: 801px)': {
        paddingRight:'70px'
      },
    },
    '& $gallery': {
      position: 'relative',
      '& > div:first-of-type':{
        overflowY:'visible',
        '@media (min-width: 801px)': {
          height:'auto'
        }
      },
      '& $slideModalMedia': {
        padding: '0',
        overflow: 'hidden',
        ...mixins.boxSizing('content-box'),
        '@media (min-width: 801px)': {
          margin: '0 auto'
        }
      },
      '& $wrapperButtons': {
        color: '#fff',
        display:'flex',
        alignItems:'center',
        justifyContent:'center',
        marginTop:'10px',
        '@media (min-width: 801px)':{
          padding:'0 50px',
          textAlign:'center',
        },
        '&:lang(ar)': {
          flexDirection: 'row-reverse',
        }
      },
      '@media (min-width: 801px)': {
        margin: '0 auto',
        maxWidth:'1420px',
        display:'flex',
        flexDirection:'column',
        justifyContent:'center',
        height:'100%',
        position:'relative'
      }
    },
    '& $modalTabsList': {
      display:'flex',
      justifyContent:'space-between',
      flexDirection:'column',
      height:'100%',
      '@media (min-width: 801px)': {
        justifyContent:'flex-start',
      },
      '& $titleListBlock': {
        display:'none',//solicitado por Mateo
        fontSize: '16px',
        padding: '0 15px',
        border: '0',
        margin: '0',
        position: 'relative',
        '&:after': {
          content: "' '",
          position: 'absolute',
          bottom: '0',
          left: 'auto',
          right: '0',
          borderBottom: '1px solid #E4E4E4',
          width: '100%'
        },
        '& > li': {
          display: 'inline-block',
          verticalAlign: 'bottom',
          position: 'relative',
          '&:not(:last-of-type)': {
            marginRight: '15px',
            '&:lang(ar)': {
              marginLeft: '15px',
              marginRight: 0
            }
          },
          '& button': {
            textTransform: 'uppercase',
            padding: '15px 3px'
          }
        },
      },
      '& $tabTitle': {
        color: '#fff',
        padding: '17px 5px 11px',
        '& $iconTitle': {
          verticalAlign: 'bottom',
          fontSize: '19px',
          padding: '2px'
        },
        '& $textTitle': {
          textTransform: 'uppercase',
          letterSpacing: '0'
        }
      },
      '& $selected': {
        borderBottom: data => '3px solid ' + data.mainColor,
        color: data => data.mainColor
      },
      '& $contentBlockStyle': {
        margin: '0 auto',
        maxWidth: '1446px',
        color: '#ffffff',
        font: data => '24px' + data.fontFamily2
      },
      '& $modalIFrame': {
        width: '100%',
        height: '100%',
        marginTop: '20px'
      },
      '&:lang(ar)': {
        textAlign: 'right'
      }
    },
    '& $tabComponent':{
      margin: '0',
      height:'100%',
      display:'flex',
      flexDirection:'column'
    },
  },
  selectedTab:{},
  buttonContainer: {},
  closeButton: {},
  headerModal: {},
  modalTitle: {},
  gallery: {},
  slideModalMedia: {},
  wrapperButtons: {},
  topButton: {
    position: 'static',
    margin: '0 0 0 auto',
    height: '40px',
    width: '40px',
    order:3,
    '& > span': {
      color: data => data.mainColor,
      fontSize: '14px',
      display:'block',
    },
    '@media (min-width: 801px)':{
      position:'absolute',
      top:0,
      bottom:0,
      height:'100%',
      right:'25px',
      textAlign:'center',
      zIndex:'501',
      margin: '0',
      '&:lang(ar)': {
        left: '25px',
        right: 'auto',
      },
    },
    '&:lang(ar)': {
      transform: 'rotate(180deg)',
    },
  },
  botButton: {
    position: 'static',
    margin: '0 auto 0 0',
    height: '40px',
    width: '40px',
    order:1,
    '& > span': {
      color: data => data.mainColor,
      fontSize: '14px',
      display:'block',
    },
    '@media (min-width: 801px)':{
      position:'absolute',
      top:0,
      bottom:0,
      height:'100%',
      left:'25px',
      textAlign:'center',
      zIndex:'501',
      margin:'0',
      '&:lang(ar)': {
        right: '25px',
        left: 'auto',
      },
    },
    '&:lang(ar)': {
      transform: 'rotate(180deg)',
    },
  },
  counterPhotoText:{
    order:2,
    fontSize:'15px',
    color:'#8B8B8B',
  },
  modalTabsList: {},
  titleListBlock: {},
  tabComponent:{},
  tabTitle: {},
  iconTitle: {},
  textTitle: {},
  selected: {},
  contentBlockStyle: {},
  modalIFrame: {},
  buttonImage: {
    left: '0',
    right:'0',
    top: '0',
    position: 'absolute',
    width:'100%',
    height:'160px',
    '& > span': {
      fontSize: '22px',
      left: '5px',
      bottom: '10px',
      position: 'absolute',
      backgroundColor: 'rgba(0,17,27,.6)',
      ...mixins.mixinBorderRadius('50%'),
      color: '#fff',
      width:'36px',
      height:'36px',
      lineHeight:'36px',
      '&:hover': {
        backgroundColor: data => data.backgroundColor,
        ...mixins.transition()
      },
      '&:lang(ar)': {
        right: '5px',
        left: 'auto'
      },
    },
    '&:lang(ar)': {
      right: '5px',
    },
    '@media (min-width: 801px)': {
      bottom:'0',
    },
    '@media (min-width: 901px)': {
      height:'100%',
      width: '267px',
    }
  },
  buttonImageSlide: {
    '@media (min-width: 901px)': {
      height:'160px',
      width: '100%'
    }
  },
  modalStyle: {
    verticalAlign: 'top'
  },
  contentTable: {
    verticalAlign: 'top'
  },
  contentFather: {
    verticalAlign: 'top',
    padding: 0
  },
  counterSpan:{
    color: '#9b9b9b'
  },
  contentTabStyle:{
    display:'flex!important',
    alignItems:'center',
    '& > div':{
      width:'100%',
      '@media (min-width: 801px)': {
        height:'100%'
      }
    }
  }
};
